import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-8 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-lg hover:bg-primary-600 transition-colors"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
    </button>
  );
}